import { message } from 'antd';
import i18n from '../i18n';
import { postWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const handleCreateMyPassword = async (data: any, onOk?: () => void) => {
  console.log('handleCreateMyPassword data', data);
  if (!data) return;

  try {
    const response = await postWithCSRF(envApiUrl + '/credentials', data);
    console.log('Create MyPasswords: response: ', response);
    message.success(i18n.t('passwords.credentialCreated'));
    onOk?.();
    return response.data;
  } catch (err: any) {
    console.error('handleCreateMyPassword error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || i18n.t('passwords.credentialCreateFailed'));
  }
};
